<template>
  <div class="table-col-warp">
    <cg-row-control :value="Value" :colInfo="colInfo" :recData="data" @sortClick="OnSortClick"></cg-row-control>
  </div>
</template>
<script>
// import RowControl from "../CmnMisControls/RowControls/RowControl";

export default {
  // components: { RowControl },
  props: {
    colInfo: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    Value() {
      return this.data[this.colInfo.ColName];
    }
  },
  methods: {
    OnSortClick(action) {
      this.$emit("sortClick", {
        RecData: this.data,
        Action: action,
        Column: this.colInfo,
      });
    },
  },
};
</script>
